import {useQuery} from 'react-query';
import {ListService} from '../Types/service';
import {getServicesByClient, getServicesInfo} from '../Api/api';

export const useGetServiceInfo = (serviceId: string) => {
  return useQuery<any, any, ListService>(
    ['serviceinfo', serviceId],
    () => getServicesInfo(serviceId),
    {enabled: serviceId !== ''}
  );
};

const VPN_SERVICES_QUERY_KEY = 'get-service-by-client-vpn';

export const useGetVpnServices = () =>
  useQuery<ListService[]>([VPN_SERVICES_QUERY_KEY], () => getServicesByClient('VPN'));

// Le détail VPN est sélectionné depuis la liste VPN (même cache que le listing).
// L'endpoint détail /api/services/{id} ne résout pas les identifiants VPN.
export const useGetVpnDetail = (serviceId: string) =>
  useQuery<ListService[], unknown, ListService | undefined>(
    [VPN_SERVICES_QUERY_KEY],
    () => getServicesByClient('VPN'),
    {
      select: (services) => services.find((s) => String(s.serviceId) === String(serviceId)),
    }
  );
